import { MISSING_DETAILS } from '../constants/missingDetails';

/**
 * Every field the held items say is missing, once each and in form order. Items held on different
 * dates can lack different fields, and the fix is one edit that fills them all.
 *
 * @param {import('../model/BillingItem.types').BillingItem[]} items
 * @returns {string[]} codes; an unknown code is kept, after the known ones, rather than dropped
 */
// eslint-disable-next-line import/prefer-default-export
export function missingDetailsOf(items) {
  const found = new Set(items.flatMap((item) => item.missingDetails ?? []));
  const rank = (code) => (MISSING_DETAILS.includes(code) ? MISSING_DETAILS.indexOf(code) : MISSING_DETAILS.length);

  return [...found].sort((a, b) => rank(a) - rank(b));
} // missingDetailsOf()
